// interlinked-tdd: exempt
// Curated MCP server catalog — Pharma portal. Hand-maintained data; add new
// servers here. Split out of curated-servers.ts to stay under the file-size cap.
import type { CuratedServer } from "./types";

export const PHARMA_SERVERS: CuratedServer[] = [
{
  "key": "klifs",
  "name": "KLIFS",
  "type": "streamable-http",
  "url": "https://klifs-mcp-server.quentincody.workers.dev/mcp",
  "description": "Kinase pockets, structures, conformations and interaction fingerprints.",
  "theme": "pharma",
  "category": "proteins & structure",
  "defaultEnabled": true
},
{
  "key": "comptox",
  "name": "EPA CompTox / CTX",
  "type": "streamable-http",
  "url": "https://comptox-mcp-server.quentincody.workers.dev/mcp",
  "description": "EPA chemical and toxicology evidence; data queries require an individual EPA API key.",
  "theme": "pharma",
  "category": "toxicology",
  "defaultEnabled": true
},
{
  "key": "sigcom-lincs",
  "name": "SigCom LINCS",
  "type": "streamable-http",
  "url": "https://sigcom-lincs-mcp-server.quentincody.workers.dev/mcp",
  "description": "Cellular perturbation signatures and dose, time and cell-line metadata.",
  "theme": "pharma",
  "category": "expression",
  "defaultEnabled": true
},
  {
    key: "openbind",
    name: "OpenBind",
    type: "streamable-http",
    url: "https://openbind-mcp-server.quentincody.workers.dev/mcp",
    description: "OpenBind — public structure-affinity data, kinetic fits, Fragalysis binding events, docking benchmarks and OpenBind-0 model discovery.",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "bindingdb",
    name: "BindingDB",
    type: "streamable-http",
    url: "https://bindingdb-mcp-server.quentincody.workers.dev/mcp",
    description: "BindingDB — measured binding affinities for ligand–target pairs, structure-activity relationships.",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "cbioportal",
    name: "cBioPortal",
    type: "streamable-http",
    url: "https://cbioportal-mcp-server.quentincody.workers.dev/mcp",
    description: "cBioPortal — cancer genomics data across 300+ studies, somatic mutations, copy number alterations, clinical…",
    theme: "pharma",
    category: "cancer",
    defaultEnabled: true,
  },
  {
    key: "chebi",
    name: "ChEBI",
    type: "streamable-http",
    url: "https://chebi-mcp-server.quentincody.workers.dev/mcp",
    description: "ChEBI — chemical ontology of small biological molecules (via EBI OLS4). Underpins ChEMBL/HMDB/KEGG…",
    theme: "pharma",
    category: "pathways",
    defaultEnabled: true,
  },
  {
    key: "chembl",
    name: "ChEMBL",
    type: "streamable-http",
    url: "https://chembl-mcp-server.quentincody.workers.dev/mcp",
    description: "Chemical compound database - 2.4M+ compounds with bioactivity, mechanisms, and ADMET data",
    theme: "pharma",
    category: "chemistry",
    defaultEnabled: true,
  },
  {
    key: "civic",
    name: "CIViC",
    type: "streamable-http",
    url: "https://civic-mcp-server.quentincody.workers.dev/mcp",
    description: "Clinical Interpretation of Variants in Cancer database",
    theme: "pharma",
    category: "variants",
    defaultEnabled: true,
  },
  {
    key: "clinicaltrials",
    name: "ClinicalTrials",
    type: "streamable-http",
    url: "https://clinicaltrialsgov-mcp-server.quentincody.workers.dev/mcp",
    description: "Access to the ClinicalTrials.gov database of clinical studies",
    theme: "pharma",
    category: "trials & immunology",
    defaultEnabled: true,
  },
  {
    key: "dailymed",
    name: "DailyMed (NLM SPL)",
    type: "streamable-http",
    url: "https://dailymed-mcp-server.quentincody.workers.dev/mcp",
    description: "NLM DailyMed — authoritative FDA Structured Product Labeling (full SPL XML with boxed warnings, supersession…",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "depmap",
    name: "DepMap",
    type: "streamable-http",
    url: "https://depmap-mcp-server.quentincody.workers.dev/mcp",
    description: "Cancer Dependency Map (Broad Institute) — per-gene CRISPR essentiality, expression, mutations, copy number…",
    theme: "pharma",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "dgidb",
    name: "DGIdb",
    type: "streamable-http",
    url: "https://dgidb-mcp-server.quentincody.workers.dev/mcp",
    description: "Drug-Gene Interaction Database",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "ema",
    name: "EMA Medicines",
    type: "streamable-http",
    url: "https://ema-mcp-server.quentincody.workers.dev/mcp",
    description: "European Medicines Agency — 2,641+ centrally authorized EU medicines, orphan designations, safety…",
    theme: "pharma",
    category: "regulatory",
    defaultEnabled: true,
  },
  {
    key: "enrichr",
    name: "Enrichr",
    type: "streamable-http",
    url: "https://enrichr-mcp-server.quentincody.workers.dev/mcp",
    description: "Enrichr — gene set enrichment against 225 libraries including KEGG, GO, LINCS L1000 drug perturbation, CRISPR…",
    theme: "pharma",
    category: "pathways",
    defaultEnabled: true,
  },
  {
    key: "faers",
    name: "FAERS",
    type: "streamable-http",
    url: "https://faers-mcp-server.quentincody.workers.dev/mcp",
    description: "FDA Adverse Event Reporting System — search adverse event reports, count reactions by field, drug safety signal…",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "fda-orange-book",
    name: "FDA Orange Book",
    type: "streamable-http",
    url: "https://fda-orange-book-mcp-server.quentincody.workers.dev/mcp",
    description: "FDA Orange Book — approved drug products, patent data with expiry dates, and market exclusivity periods",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "gprofiler",
    name: "g:Profiler",
    type: "streamable-http",
    url: "https://gprofiler-mcp-server.quentincody.workers.dev/mcp",
    description: "g:Profiler — gene set enrichment analysis (GO, KEGG, Reactome, WikiPathways, HP, MIRNA, TF, CORUM, HPA), gene…",
    theme: "pharma",
    category: "expression",
    defaultEnabled: true,
  },
  {
    key: "gtopdb",
    name: "Guide to Pharmacology (IUPHAR)",
    type: "streamable-http",
    url: "https://gtopdb-mcp-server.quentincody.workers.dev/mcp",
    description: "IUPHAR/BPS Guide to Pharmacology — receptor/ligand pharmacology with curated target families, ligand…",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "iedb",
    name: "IEDB",
    type: "streamable-http",
    url: "https://iedb-mcp-server.quentincody.workers.dev/mcp",
    description: "Immune Epitope Database — MHC class I/II binding predictions, B-cell epitope prediction, antigen processing…",
    theme: "pharma",
    category: "trials & immunology",
    defaultEnabled: true,
  },
  {
    key: "kegg",
    name: "KEGG",
    type: "streamable-http",
    url: "https://kegg-mcp-server.quentincody.workers.dev/mcp",
    description: "KEGG REST — pathway, disease, drug, orthology, and compound data. Gold standard for non-human pathways and…",
    theme: "pharma",
    category: "pathways",
    defaultEnabled: true,
  },
  {
    key: "nci-cts",
    name: "NCI Clinical Trial Search",
    type: "streamable-http",
    url: "https://nci-cts-mcp-server.quentincody.workers.dev/mcp",
    description: "NCI Clinical Trials Search API — structured biomarker-based cancer trial matching with NCI Thesaurus disease…",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "nci-gdc",
    name: "NCI GDC",
    type: "streamable-http",
    url: "https://nci-gdc-mcp-server.quentincody.workers.dev/mcp",
    description: "NCI GDC",
    theme: "pharma",
    category: "cancer",
    defaultEnabled: true,
  },
  {
    key: "nci-pdc",
    name: "NCI PDC",
    type: "streamable-http",
    url: "https://nci-pdc-mcp-server.quentincody.workers.dev/mcp",
    description: "NCI PDC",
    theme: "pharma",
    category: "cancer",
    defaultEnabled: true,
  },
  {
    key: "openfda",
    name: "OpenFDA",
    type: "streamable-http",
    url: "https://openfda-mcp-server.quentincody.workers.dev/mcp",
    description: "FDA drug label database — search labels by brand/generic/ingredient, full label detail by NDA number, black box…",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "opentargets",
    name: "OpenTargets",
    type: "streamable-http",
    url: "https://open-targets-mcp-server.quentincody.workers.dev/mcp",
    description: "Access to OpenTargets genetics and drug discovery data",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "pharos",
    name: "Pharos",
    type: "streamable-http",
    url: "https://pharos-mcp-server.quentincody.workers.dev/mcp",
    description: "Pharos",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "proteomics",
    name: "Proteomics (PRIDE + ProteomeXchange + ProteomicsDB)",
    type: "streamable-http",
    url: "https://proteomics-mcp-server.quentincody.workers.dev/mcp",
    description: "PRIDE Archive + ProteomeXchange (PROXI) under one server — projects, files, peptides, proteins, spectra; ProteomicsDB expression and peptide evidence.",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "pubchem",
    name: "PubChem",
    type: "streamable-http",
    url: "https://pubchem-mcp-server.quentincody.workers.dev/mcp",
    description: "PubChem — 110M+ compounds, bioassays, toxicity, properties, similarity/substructure search via PUG REST",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "reactome",
    name: "Reactome",
    type: "streamable-http",
    url: "https://reactome-mcp-server.quentincody.workers.dev/mcp",
    description: "Reactome pathway database — pathway enrichment analysis, pathway contents, entity lookup, reactions",
    theme: "pharma",
    category: "pathways",
    defaultEnabled: true,
  },
  {
    key: "rhea",
    name: "Rhea",
    type: "streamable-http",
    url: "https://rhea-mcp-server.quentincody.workers.dev/mcp",
    description: "Rhea — expert-curated database of biochemical reactions linking ChEBI and UniProt.",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "rxnorm",
    name: "RxNorm",
    type: "streamable-http",
    url: "https://rxnorm-mcp-server.quentincody.workers.dev/mcp",
    description: "NLM RxNorm drug database — search drugs by name, look up RxCUI details, check drug-drug interactions, and…",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "sec-edgar",
    name: "SEC EDGAR",
    type: "streamable-http",
    url: "https://sec-edgar-mcp-server.quentincody.workers.dev/mcp",
    description: "SEC EDGAR public read APIs for company submissions, company facts, filing indexes, and XBRL frame queries",
    theme: "pharma",
    category: "pharma",
    defaultEnabled: true,
  },
  {
    key: "tcia",
    name: "TCIA",
    type: "streamable-http",
    url: "https://tcia-mcp-server.quentincody.workers.dev/mcp",
    description: "The Cancer Imaging Archive — 152+ cancer imaging collections, patient/study/series metadata, DICOM modalities…",
    theme: "pharma",
    category: "imaging & neuro",
    defaultEnabled: true,
  },
  {
    key: "unichem",
    name: "UniChem",
    type: "streamable-http",
    url: "https://unichem-mcp-server.quentincody.workers.dev/mcp",
    description: "UniChem — compound cross-references across 40+ sources (ChEMBL, PubChem, KEGG, HMDB, ZINC, DrugBank, ChEBI…",
    theme: "pharma",
    category: "proteins & structure",
    defaultEnabled: true,
  },
  {
    key: "wikipathways",
    name: "WikiPathways",
    type: "streamable-http",
    url: "https://wikipathways-mcp-server.quentincody.workers.dev/mcp",
    description: "WikiPathways — 3K+ community-curated biological pathways (CC0 license), searchable by gene, compound, or…",
    theme: "pharma",
    category: "pathways",
    defaultEnabled: true,
  },
  {
    key: "fda-purple-book",
    name: "FDA Purple Book",
    type: "streamable-http",
    url: "https://fda-purple-book-mcp-server.quentincody.workers.dev/mcp",
    description: "FDA Purple Book — licensed biologics, biosimilars, interchangeables, and exclusivity expiry (biologics complement to the Orange Book)",
    theme: "pharma",
    category: "drugs & targets",
    defaultEnabled: true,
  },
  {
    key: "catalysishub",
    name: "Catalysis Hub",
    type: "streamable-http",
    url: "https://catalysis-hub-mcp-server.quentincody.workers.dev/mcp",
    description: "Catalysis Hub — computational catalysis: surface reaction energetics, adsorption energies, and DFT-calculated structures.",
    theme: "pharma",
    category: "chemistry",
    defaultEnabled: true,
  },
  {
    key: "finra",
    name: "FINRA",
    type: "streamable-http",
    url: "https://finra-mcp-server.quentincody.workers.dev/mcp",
    description: "FINRA — securities market data: short interest, equity/debt filings and regulatory disclosures (pairs with SEC EDGAR for pipeline & catalyst work).",
    theme: "pharma",
    category: "market & regulatory",
    defaultEnabled: true,
  },
];
